import { useEffect, useRef } from 'react';

/**
 * Trap focus within container when active. Return focus to returnRef on deactivate.
 */
export function useFocusTrap(active, containerRef, returnRef) {
  const previousActive = useRef(false);

  useEffect(() => {
    if (!active) {
      if (previousActive.current && returnRef?.current) {
        returnRef.current.focus();
      }
      previousActive.current = false;
      return;
    }
    previousActive.current = true;
    const container = containerRef?.current;
    if (!container) return;

    const focusables = container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (first) first.focus();

    const onKeyDown = (e) => {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last?.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first?.focus();
        }
      }
    };

    container.addEventListener('keydown', onKeyDown);
    return () => container.removeEventListener('keydown', onKeyDown);
  }, [active, containerRef, returnRef]);
}
